<template>
<div>
    <b-modal id="clientAveragePaymentDurationInvoiceListModal" centered size="xl" no-close-on-backdrop ref="clientAveragePaymentDurationInvoiceListModal" :title="this.titleText + ' - ' + $t('clientAveragePaymentDurationInvoice.title')" hide-footer @close="clear()">
        <b-row>
            <b-col class="col-md-12 mb-1 custom-search d-flex justify-content-end">
                <b-button size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
            </b-col>
        </b-row>
        <vue-good-table id="clientAveragePaymentDurationInvoiceTable" ref="clientAveragePaymentDurationInvoiceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Column -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'proformaDate'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.invoice_date') }}
                </span>
                <span v-else-if="props.column.field === 'debitNo'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.debit_no') }}
                </span>
                <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.amount') }}
                </span>
                <span v-else-if="props.column.field === 'currencyCode'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.currency_code') }}
                </span>
                <span v-else-if="props.column.field === 'paymentDate'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.payment_date') }}
                </span>
                <span v-else-if="props.column.field === 'paymentDuration'" class="text-nowrap">
                    {{ $t('clientAveragePaymentDurationInvoice.payment_duration') }}
                </span>
            </template>
            <!-- Column: Table Row Data -->
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'proformaDate'">
                    {{ $formatFn(props.row.proformaDate) }}
                </span>
                <span v-else-if="props.column.field === 'invoiceTotal'">
                    {{ $formatMoney(props.row.invoiceTotal) }}
                </span>
                <span v-else-if="props.column.field === 'paymentDate'">
                    {{ $formatFn(props.row.paymentDate) }}
                </span>
                <span v-else-if="props.column.field === 'paymentDuration'">
                    {{ parseFloat(props.row.paymentDuration).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) }}
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}</span>
                        <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            titleText: '',
            clientAccountingId: 0,
            columns: [{
                    label: this.$t('clientAveragePaymentDurationInvoice.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.invoice_date'),
                    field: `proformaDate`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.payment_date'),
                    field: `paymentDate`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.payment_duration'),
                    field: `paymentDuration`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.e_invoice_no'),
                    field: `eInvoiceNo`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.e_invoice_date'),
                    field: `eInvoiceDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.amount'),
                    field: `invoiceTotal`,
                },
                {
                    label: this.$t('clientAveragePaymentDurationInvoice.currency_code'),
                    field: `currencyCode`,
                },

            ],
            rows: [],

        }
    },
    methods: {
        clear() {
            this.rows = []
            this.clientAccountingId = 0
            this.titleText = ''
        },
        getClientInvoiceListForAveragePaymentDurationReport(clientAccountingId, clientName, startDate, endDate) {
            this.$refs.clientAveragePaymentDurationInvoiceListModal.show()
            this.rows = []
            this.clientAccountingId = clientAccountingId
            this.titleText = clientName || ''
            const controller = {
                name: 'Invoice',
                actionName: 'GetClientInvoiceListForAveragePaymentDurationReport'
            }
            const data = {
                clientAccountingId: clientAccountingId,
                startDate: startDate || null,
                endDate: endDate || null,
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.clientInvoiceList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {
            const controller = {
                name: 'Invoice',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(this.titleText + ' - ' + this.$t('clientAveragePaymentDurationInvoice.title'), response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    }
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
